var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-filter-list global-filter-list--vue" },
    [
      _c(
        "span",
        {
          staticClass: "filter-label",
          class: { "filter-label--always": _vm.alwaysShowFilterLabel },
        },
        [_vm._v(_vm._s(_vm.filterLabel))]
      ),
      _vm._v(" "),
      _vm.selectedOption
        ? _c(
            "div",
            {
              staticClass: "filter--list filter__head",
              on: { click: _vm.toggleBody },
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "filter filter--secondary icon--after icon--absolute",
                  class: {
                    "icon--arrow-down": !_vm.open,
                    "icon--arrow-up": _vm.open,
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.selectedOption.title) + " "
                  ),
                  typeof _vm.selectedOption.count !== "undefined"
                    ? _c("span", { staticClass: "counter" }, [
                        _vm._v("(" + _vm._s(_vm.selectedOption.count) + ")"),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "filter--list filter__body",
          style: _vm.open ? "display: block" : "",
        },
        _vm._l(_vm.options, function (option) {
          return _c("li", { key: option.value }, [
            _c(
              "a",
              {
                staticClass: "filter filter--secondary",
                class: { active: _vm.isActive(option) },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    return _vm.selectOption(option, $event)
                  },
                },
              },
              [
                _vm._v("\n                " + _vm._s(option.title) + " "),
                typeof option.count !== "undefined"
                  ? _c("span", { staticClass: "counter" }, [
                      _vm._v("(" + _vm._s(option.count) + ")"),
                    ])
                  : _vm._e(),
              ]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }